import { useCallback, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import queryString, { StringifiableRecord, StringifyOptions } from 'query-string';

import { QueryType } from './type';

const options = { parseBooleans: true };

export const useQuery = () => {
  const location = useLocation();
  const history = useHistory();

  const pathname = useMemo(() => {
    const windowPathname = window.location.pathname;

    // если манипуляции с урлом происходят не через react-router то приоритетнее window.location.pathname
    // (в location из реакт-роутера останется старый необновленный location)
    if (location.pathname !== windowPathname) return windowPathname;
    return location.pathname;
  }, [location.pathname]);

  const query = useMemo(() => queryString.parse(location.search, options), [location.search]);

  const pushQuery = useCallback(
    (queryObj: QueryType) => {
      const modifiedQuery = {
        ...query,
        ...queryObj,
      } as StringifiableRecord;

      history.push({
        pathname,
        search: queryString.stringify(modifiedQuery),
      });
    },
    [history, pathname, query],
  );

  const replaceQuery = useCallback(
    (queryObj: QueryType, options?: StringifyOptions) => {
      const modifiedQuery = {
        ...query,
        ...queryObj,
      } as StringifiableRecord;

      history.replace({
        pathname,
        search: queryString.stringify(modifiedQuery, options),
      });
    },
    [history, pathname, query],
  );

  return { query, pushQuery, replaceQuery, pathname };
};
